// extracted by mini-css-extract-plugin
module.exports = {"image":"ImageComponent_image__3EchS"};